import { genericRequest, processedSectionsRoute } from "./service"

/**
 * Gets the processed THz heatmap image for a section.
 * 
 * @param sectionId of section to fetched THz heatmap image for
 * 
 * @returns processed THz heatmap of the given section
 */
export const getProcessedTHzHeatmapImage = async (sectionId: number) => {
  return genericRequest({ url: `${processedSectionsRoute}/thz_heatmap_image/${sectionId}`, method: "GET" })
}
